module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAARCAYAAADDjbwNAAAAAXNSR0IArs4c6QAAANxJREFUOE+9laEOwjAURc/9ChAkIBFILIJPIGGCD+MvJhAIHCTgMCTwKQgEySMl2wJl6xLW7ZmK1/a0973eikCY2RBYAmtJj9DcupyqJmSQAzACZpJOdZuF8qUgD5JKSppA3NofkA8BVpKeUUFtQb5u5EG2wCLGTXIl3tKZWQ9whR8DuwzSqMt8qdUF5C2dmZ2BaXaCO9C48CWNc3OgKzBpGXRxoD6wb7M+Rdd1ASserJkNgGNmORsgid7eefHMzPmak9GNaSxXqLKgVmBVphodFvomPmFzSc45/o4X0oFjjlIiTtkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/gol.png
// module id = 0ccl
// module chunks = 2